export const APP_IS_OPENED = "App is opened";
export const TO_BACKOFFICE_SELECTED = "To Backoffice selected";
export const TO_ASANA_SELECTED = "To Asana selected";

export const SUGGESTED_FM_ON_THE_MAP_SELECTED =
  "Suggested FM on the map selected";
export const COMPLETE_FM_ON_THE_MAP_SELECTED =
  "Completed FM on the map selected";
export const FM_POPUP_IS_CLOSED = "FM popup is closed";
export const REQUESTED_FM_ON_THE_MAP_SELECTED =
  "Requested FM on the map selected";
export const ACTIVE_FM_ON_THE_MAP_SELECTED = "Active FM on the map selected";
export const FIT_SITE_SELECTED = "Fit Site selected";
export const SHOW_GCP_LABELS_IS_SWITCHED_ON = "Show GCP Labels is switched on";
export const SHOW_GCP_LABELS_IS_SWITCHED_OFF =
  "Show GCP Labels is switched off";

export const SUGGESTED_FM_IN_SIDEBAR_SELECTED =
  "Suggested FM in sidebar selected";
export const COMPLETE_FM_IN_SIDEBAR_SELECTED =
  "Complete FM in sidebar selected";
export const SIDEBAR_CLOSED = "Sidebar closed";
export const SIDEBAR_OPENED = "Sidebar opened";
export const SWITCH_ON_ACTIVE_FM = "Switch on Active FM";
export const SWITCH_OFF_ACTIVE_FM = "Switch off Active FM";
export const SWITCH_ON_EXISTING_FM = "Switch on Existing FM";
export const SWITCH_OFF_EXISTING_FM = "Switch off Existing FM";
export const SWITCH_ON_REQUESTED_FM = "Switch on Requested FM";
export const SWITCH_OFF_REQUESTED_FM = "Switch off Requested FM";
export const ACTIVE_FM_EXPANDED = "Active FM expanded";
export const REQUESTED_FM_EXPANDED = "Requested FM expanded";
export const ACTIVE_FM_COLLAPSED = "Active FM collapsed";
export const REQUESTED_FM_COLLAPSED = "Requested FM collapsed";
export const ACTIVE_FM_CHOSEN_IN_SIDEBAR = "Active FM chosen in sidebar";
export const REQUESTED_FM_CHOSEN_IN_SIDEBAR = "Requested FM chosen in sidebar";

export const FM_MARKED_COMPLETE = "FM marked complete";
export const FM_MARKED_INCOMPLETE = "FM marked incomplete";

export const GEOLOCATION_IS_ENABLED = "Geolocation is enabled";
export const GEOLOCATION_IS_DISABLED = "Geolocation is disabled";

export const OSM_MAP_SELECTED = "OSM map selected";
export const SATELLITE_MAP_SELECTED = "Satellite map selected";
export const DEM_SELECTED = "DEM selected";
export const ORTHOPHOTO_SELECTED = "Orthophoto selected";

export const MOVE_FM_MANUALLY_SELECTED = "Move FM manually selected";
export const FM_LOCATION_UPDATED = "FM location updated";

export const ALL_CSV_DOWNLOADED = "All csv downloaded";
export const ALL_CSV_WGS_DOWNLOADED = "All csv (WGS 84) downloaded";
export const REQUESTED_CSV_DOWNLOADED = "Requested csv downloaded";
export const REQUESTED_CSV_WGS_DOWNLOADED = "Requested csv (WGS 84) downloaded";
export const ALL_GPX_DOWNLOADED = "All gpx downloaded";
export const REQUESTED_GPX_DOWNLOADED = "Requested gpx downloaded";
export const INITIAL_CSV_DOWNLOADED = "Initial CSV downloaded";
export const INITIAL_CSV_WGS_DOWNLOADED = "Initial CSV (WGS 84) downloaded";
export const INITIAL_GPX_DOWNLOADED = "Initial GPX downloaded";
